module.exports = __webpack_public_path__ + "img/coopCoop.9ad21491.png";